<template>
    <div class="my-set-sub-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>
        <!-- 2. 提示内容 -->
        <div class="my-set-telephone-content">
            <h3>设置登录密码</h3>
        </div>
        <!-- 3. 表单 -->
        <div class="my-set-telephone-form">
            <div class="my-set-line dsp-flex">
                <div class="my-set-cur-tel">{{userData.mobile}}</div>
                <div class="my-set-line-right">
                    <span class="my-set-lrb"></span>
                    <button class="my-set-verify" @click="clickChangeTel"><span>更换手机号</span></button>
                </div>
            </div>
            <div v-if="loginData.havePwd == 1" class="my-set-line dsp-flex">
                <input class="my-set-input" placeholder="请输入旧密码" @input="inputPwd" v-model="oldPwd" maxlength="20" v-bind:type="oldPwdShow ? 'text' : 'password'">
                <div class="my-set-line-icon" @click="clicktoggleShow('old')"><i class="iconfont " v-bind:class="{'icon-show': oldPwdShow, 'icon-hide': !oldPwdShow}"></i></div>
            </div>
            <div class="my-set-line dsp-flex">
                <input class="my-set-input" placeholder="输入8位以上的新密码" @input="inputPwd" v-model="newPwd" maxlength="20" v-bind:type="newPwdShow ? 'text' : 'password'">
                <div class="my-set-line-icon" @click="clicktoggleShow('new')"><i class="iconfont" v-bind:class="{'icon-show': newPwdShow, 'icon-hide': !newPwdShow}"></i></div>
            </div>
            <div class="my-set-line dsp-flex">
                <input class="my-set-input" placeholder="请确认新密码" @input="inputPwd" v-model="againPwd" maxlength="20" v-bind:type="againPwdShow ? 'text' : 'password'">
                <div class="my-set-line-icon" @click="clicktoggleShow('again')"><i class="iconfont" v-bind:class="{'icon-show': againPwdShow, 'icon-hide': !againPwdShow}"></i></div>
            </div>
        </div>
        <!-- 4. 按钮 -->
        <div class="my-set-button">
            <button class="button-green" v-bind:class="{'button-gray': !canClick}" v-bind:disabled="!canClick" @click="clickSetPwd">设置密码</button>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import { CONFIG } from '../../modules/config';
import { MIX } from '../../modules/utils';
export default {
    name: 'MySetPassword',
    components: { TitleBar },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        loginData() {
            return this.$store.state.loginData;
        }
    },
    data() {
        return {
            titleData: {'titleText': '', 'showCancel': false},
            oldPwd: '', oldPwdShow: false,
            newPwd: '', newPwdShow: true,
            againPwd: '', againPwdShow: true,
            canClick: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.$store.dispatch('checkUserPwd');
            MIX.trackPageViewed('PasswordSetting');
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
        },
        clickBack() {
            this.$router.replace('/my');
        },
        clickChangeTel() {
            this.$router.replace('/my/settel');
        },
        clicktoggleShow(type) {
            switch(type) {
                case 'old':
                    this.oldPwdShow = !this.oldPwdShow;
                    break;
                case 'new':
                    this.newPwdShow = !this.newPwdShow;
                    break;
                case 'again':
                    this.againPwdShow = !this.againPwdShow;
                    break;
                default:
                    break;
            }
        },
        inputPwd() {
            var oldPwd = this.loginData.havePwd == 1 ? this.oldPwd : true;
            this.canClick = oldPwd && this.newPwd && this.againPwd;
        },
        clickSetPwd() {
            console.log('clickSetPwd-------', this.newPwd, this.againPwd)
            if(this.newPwd != this.againPwd) {
                this.$toast('两次输入的密码不相同');
                return;
            }
            if(this.newPwd.length < 8) {
                this.$toast('请输入8位以上的密码');
                return;
            }
            var me = this,
                oldPwd = this.loginData.havePwd == 1 ? this.oldPwd : '';
            this.$store.dispatch('changePassword', {
                old: oldPwd,
                new: this.newPwd,
                sucCb: function() {
                    me.$toast('修改密码成功，页面重新授权登录！');
                    me.$router.replace('/collate');
                    // 重新跳转到授权页面
                    setTimeout(() => {
                        if(CONFIG.platform == 'qq') {
                            window.location.href = CONFIG.getQQAuthUrl();
                        }else if(CONFIG.platform == 'wechat') {
                            window.location.href = CONFIG.getWechatAuthUrl();
                        }
                    }, 100);
                }
            })
        }
    }
}
</script>